




import { Component, Vue, Prop } from 'vue-property-decorator';
import { IIssue } from '@/lib/interfaces';

@Component
export default class PriorIcon extends Vue {
  @Prop() private prior!: number;

  private get style(): { 'background-color': string } {
    let result: { 'background-color': string };
    if (this.prior < 3) {
      result = {
        'background-color': 'green',
      };
    } else if (this.prior < 7) {
      result = {
        'background-color': 'orange',
      };
    } else {
      result = {
        'background-color': 'red',
      };
    }
    return result;
  }
}
